export default __webpack_public_path__ + "static/media/add.5b554d50.png";